import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Breadcrumb } from 'antd';

import styles from './CompensationBreadcrumbs.module.scss';

export interface CompensationBreadcrumbsProps {
  readonly mainBreadcrumbLink: string;
  readonly mainBreadcrumbTitle: string;
}

interface Props {
  readonly breadcrumbs: CompensationBreadcrumbsProps;
}

export const CompensationBreadcrumbs = ({ breadcrumbs }: Props) => {
  const { t } = useTranslation();
  const { mainBreadcrumbLink, mainBreadcrumbTitle } = breadcrumbs;

  return (
    <Breadcrumb
      className={styles.breadcrumbs}
      separator="›"
      items={[
        {
          title: (
            <NavLink to={mainBreadcrumbLink} className={styles.mainBreadcrumb}>
              {mainBreadcrumbTitle}
            </NavLink>
          ),
        },
        {
          title: <span className={styles.secondaryBreadcrumb}>{t('requestDetails')}</span>,
        },
      ]}
    />
  );
};
